// eslint-disable-next-line import/prefer-default-export
export const EMAIL_SUCCESS = 'EmailSuccess';
export const FU_PROMPT_PAGE_NAME = 'forgot-username:enter-email-mobile';
export const FU_CONFIRM_PAGE_NAME = 'forgot-username:email-sent';

export const forgotUsernameTransaction = {
  name: "New! 'forgot-username'",
  type: 'Self-serve',
  category: 'Non-financial',
};
